"use strict";

require("core-js/modules/es.object.define-property.js");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

require("core-js/modules/es.date.now.js");

require("core-js/modules/es.date.to-string.js");

require("core-js/modules/es.array.index-of.js");

require("core-js/modules/web.url.js");

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/es.string.iterator.js");

require("core-js/modules/web.dom-collections.iterator.js");

require("core-js/modules/es.array.for-each.js");

require("core-js/modules/web.dom-collections.for-each.js");

require("core-js/modules/es.array.map.js");

require("core-js/modules/es.array.includes.js");

require("core-js/modules/es.array.splice.js");

require("core-js/modules/es.parse-int.js");

require("core-js/modules/es.array.find-index.js");

require("core-js/modules/es.function.name.js");

require("element-ui/lib/theme-chalk/src/base.css");

require("element-ui/lib/theme-chalk/src/notification.css");

var _notification2 = _interopRequireDefault(require("element-ui/lib/notification"));

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread2"));

var _lodash = _interopRequireDefault(require("lodash"));

var _skAxios = require("sk-axios");

var _util = require("sk-ui/lib/utils/util.js");

var _api = require("sk-web-framework/api");

var _index2 = require("sk-web-framework/api/index");

var _router = _interopRequireDefault(require("sk-web-framework/router"));

var _utils = require("sk-web-framework/utils");

var _debounce = _interopRequireDefault(require("throttle-debounce/debounce"));

var _lang = _interopRequireDefault(require("@/lang"));

var _store = _interopRequireDefault(require("@/store"));

var STATUS_MAP = {
  partial_success: 'error',
  failure: 'error',
  error: 'error',
  success: 'success',
  warning: 'warning',
  info: 'info',
  processing: 'warning'
};
var debounceTime = 10;
var debounceOpenRalationDialog = (0, _debounce["default"])(debounceTime, function (_ref) {
  var metaData = _ref.metaData,
      props = _ref.props,
      clone = _ref.clone;
  clone && (metaData = (0, _util.extend)(true, {}, metaData["default"]));

  if (!metaData.view.formItemId) {
    metaData.view.formItemId = null;
  }

  (0, _utils.backfill)(metaData, (0, _objectSpread2["default"])({}, props));
  var viewMetaData = {
    metaData: metaData,
    type: 'right'
  };

  _store["default"].dispatch('AddDialogMetaData', viewMetaData);

  _store["default"].dispatch('AddBreadcrumbMetaData', viewMetaData);
});
var debounceOpenFullDialog = (0, _debounce["default"])(debounceTime, function (_ref2) {
  var metaData = _ref2.metaData,
      props = _ref2.props,
      clone = _ref2.clone;
  clone && (metaData = (0, _util.extend)(true, {}, metaData));
  (0, _utils.backfill)(metaData, (0, _objectSpread2["default"])({}, props));
  var viewMetaData = {
    metaData: metaData,
    type: 'full' // modal: !!metaData.modal   // 支持模态框，目前存在bug

  };

  _store["default"].dispatch('AddDialogMetaData', viewMetaData);

  _store["default"].dispatch('AddBreadcrumbMetaData', viewMetaData);
});
var debounceOpenDetailDialog = (0, _debounce["default"])(debounceTime, function (_ref3) {
  var metaData = _ref3.metaData,
      props = _ref3.props,
      clone = _ref3.clone;
  clone && (metaData = (0, _util.extend)(true, {}, metaData));
  (0, _utils.backfill)(metaData, (0, _objectSpread2["default"])({}, props));
  var viewMetaData = {
    metaData: metaData,
    type: 'detail'
  };

  _store["default"].dispatch('AddDialogMetaData', viewMetaData);

  _store["default"].dispatch('AddBreadcrumbMetaData', viewMetaData);
});
var debounceOpenRightDialog = (0, _debounce["default"])(debounceTime, function (_ref4) {
  var metaData = _ref4.metaData,
      props = _ref4.props,
      clone = _ref4.clone;
  clone && (metaData = (0, _util.extend)(true, {}, metaData));
  (0, _utils.backfill)(metaData, (0, _objectSpread2["default"])({}, props));
  var viewMetaData = {
    metaData: metaData,
    type: 'right'
  };

  _store["default"].dispatch('AddDialogMetaData', viewMetaData);

  _store["default"].dispatch('AddBreadcrumbMetaData', viewMetaData);
}); // const debounceDownLoadFile = debounce(500, ({ module, action, params }) => {
//   params.downloadSpecialId = Date.parse(new Date());
//   return download(module, action, params);
// });

var debounceDownLoadFile = (0, _debounce["default"])(10, function (_ref5) {
  var module = _ref5.module,
      action = _ref5.action,
      params = _ref5.params;
  // params.downloadSpecialId = Date.parse(new Date()); // 用于区别每个下载项
  params.downloadSpecialId = Date.now(); // 用于区别每个下载项

  return (0, _api.download)(module, action, params).then(function (response) {
    // 处理返回的文件流
    if (!response || response.status === 'ERROR') {
      return;
    }

    var contentDisposition = response.headers['content-disposition'];

    if (!contentDisposition) {
      return response;
    }

    var fileNameIndex = contentDisposition.indexOf('filename');
    var fileName = '';

    if (fileNameIndex > -1) {
      var startIndex = contentDisposition.indexOf('=', fileNameIndex);
      var endIndex = contentDisposition.indexOf(';', startIndex);

      if (endIndex === -1) {
        fileName = contentDisposition.substring(startIndex + 1);
      } else {
        fileName = contentDisposition.substring(startIndex + 1, endIndex);
      }
    }

    var url = window.URL.createObjectURL(new Blob([response.data]));
    (0, _api.downloadFile)(url, fileName); // const link = document.createElement('a')
    // link.style.display = 'none'
    // link.href = url
    // link.setAttribute('download', fileName)
    // document.body.appendChild(link)
    // link.click()
    // link.remove();
  })["catch"](function (e) {
    if (e.config && e.config.params) {
      // 处理前端异常，如超时
      _store["default"].state.operate.skyLoaders.forEach(function (skyLoader, index) {
        if (e.config.params.downloadSpecialId === skyLoader.downloadSpecialId) {
          skyLoader.files[0].status = 'fail';

          _store["default"].dispatch('UpdateSkyLoader', {
            index: index,
            downloader: skyLoader
          });
        }
      });
    }
  });
});
/**
 * matchs中找到匹配target的项，并删除该matchs[target] 之后的所有项
 * @param {*} target
 * @param {*} matchs
 */

var removeMatchMetaData = function removeMatchMetaData(target, matchs) {
  var _target$metaData, _target$metaData$view;

  if (!matchs || matchs.length <= 0) {
    return;
  }

  var breadcrumb = target === null || target === void 0 ? void 0 : (_target$metaData = target.metaData) === null || _target$metaData === void 0 ? void 0 : (_target$metaData$view = _target$metaData.view) === null || _target$metaData$view === void 0 ? void 0 : _target$metaData$view.breadcrumb;
  var targetFlagIds = [];

  if (_lodash["default"].isArray(breadcrumb) && breadcrumb.length > 0) {
    breadcrumb.map(function (bread) {
      (bread === null || bread === void 0 ? void 0 : bread.id) && targetFlagIds.push(bread.id);
    });
  } else {
    (breadcrumb === null || breadcrumb === void 0 ? void 0 : breadcrumb.id) && targetFlagIds.push(breadcrumb.id);
  }

  if (targetFlagIds.length > 0) {
    for (var i = 0; i < matchs.length; i++) {
      var _matchs$i;

      var matchFlagId = (_matchs$i = matchs[i]) === null || _matchs$i === void 0 ? void 0 : _matchs$i.id;

      if (targetFlagIds.includes(matchFlagId)) {
        var removeLen = matchs.length - i;
        matchs.splice(i, removeLen);
        break;
      }
    }
  }
};

function noop() {}

var app = {
  state: {
    showDetailPage: false,
    dialogMetaDatas: [],
    breadcrumbMetaDatas: [],
    // popoverMetaData: null,
    refreshView: {
      cid: 0,
      data: null,
      taskId: null
    },
    selectItems: [],
    skyLoaders: [],
    // 异步上传文件，上传组件容器,
    asyncAction: false,
    // 异步动作执行中，如上传文件比较
    relationSearchKeyword: null,
    // 关联查询栏关键字
    vncOperate: '',
    taskIds: [],
    // 当前异步任务id
    currentAction: '',
    // 执行 操作名称，action名称
    inprocessing: false,
    // 同步处理数据，时间等待比较长，系统正在处理中，请稍候提示
    initLoading: false,
    hasFirstTimeLoggedIn: false,
    asynchronousTasks: [],
    // 保存上传文件异步任务订阅列表: [{id, [success], [fail], taskId}],
    refreshTimerId: null // permission_buttons: null

  },
  mutations: {
    SET_INITLOADING: function SET_INITLOADING(state, initLoading) {
      state.initLoading = initLoading;
    },
    SET_REFRESH_TIMER_ID: function SET_REFRESH_TIMER_ID(state, refreshTimerId) {
      state.refreshTimerId = refreshTimerId;
    },
    SET_HAS_FIRST_TIME_LOGGED_IN: function SET_HAS_FIRST_TIME_LOGGED_IN(state, hasFirstTimeLoggedIn) {
      state.hasFirstTimeLoggedIn = hasFirstTimeLoggedIn;
    },
    SET_PROCESSING: function SET_PROCESSING(state, processing) {
      state.inprocessing = processing;
    },
    SET_DETAIL_PAGEHIDDEN_OPERATE: function SET_DETAIL_PAGEHIDDEN_OPERATE(state, showDetailPage) {
      state.showDetailPage = showDetailPage;
    },
    SET_ASYNC_ACTION: function SET_ASYNC_ACTION(state, asyncAction) {
      state.asyncAction = asyncAction;
    },
    // SET_POPOVER_METADATA: (state, popoverMetaData) => {
    //   state.popoverMetaData = popoverMetaData;
    // },

    /**
     * @param {*} metaData 删除的个数，'all' 表示删除所有，false 表示删除最后一个，num表示删除第num个之后的dialog以及对应的面包屑（不包含第num个；num是dialog下标，从0开始）
     */
    REMOVE_DIALOG_META_DATA: function REMOVE_DIALOG_META_DATA(state, metaData) {
      if (metaData === 'all') {
        state.asyncAction = false;
        state.dialogMetaDatas = [];
        state.breadcrumbMetaDatas = [];
      } else {
        var removeDialogIdx = parseInt(metaData) + 1;

        if (metaData === false) {
          removeDialogIdx = state.dialogMetaDatas.length - 1;
        } // 轮询matchs：breadcrumbMetaDatas，找到匹配dialog的breadcrumbMetaData，并删除该项及之后的所有breadcrumbMetaData


        var target = state.dialogMetaDatas[removeDialogIdx];
        var matchs = state.breadcrumbMetaDatas;
        removeMatchMetaData(target, matchs); // 必须先根据dialogMetaDatas找到对应breadcrumb才能删除dialogMetaDatas

        var removeLen = state.dialogMetaDatas.length - removeDialogIdx; // dialog删除的长度

        state.dialogMetaDatas.splice(removeDialogIdx, removeLen);
      }
    },
    ADD_DIALOG_META_DATA: function ADD_DIALOG_META_DATA(state, metaData) {
      if (!metaData) {
        return;
      }

      state.dialogMetaDatas.push(metaData);
    },
    ADD_BREADCRUMB_META_DATA: function ADD_BREADCRUMB_META_DATA(state, _ref6) {
      var metaData = _ref6.metaData;

      if (!metaData || !metaData.view || !metaData.view.breadcrumb) {
        return;
      } // 未配置action或者路由上的action


      var originAction = 'RemoveBreadcrumbMetaData';
      var breadcrumbs = _lodash["default"].isArray(metaData.view.breadcrumb) ? metaData.view.breadcrumb : [metaData.view.breadcrumb];

      for (var i = 0; i < breadcrumbs.length; i++) {
        // 唯一id，作为移除面包屑标志
        breadcrumbs[i].id = Date.now() + i;
        breadcrumbs[i].action = breadcrumbs[i].action || originAction;
        breadcrumbs[i].originAction = originAction;
        state.breadcrumbMetaDatas.push(breadcrumbs[i]);
      }
    },
    ADD_SKY_LOADER: function ADD_SKY_LOADER(state, skyLoader) {
      if (!skyLoader) {
        return;
      }

      state.skyLoaders.push(skyLoader);
    },
    REMOVE_SKY_LOADER: function REMOVE_SKY_LOADER(state, params) {
      var skyLoadersLen = state.skyLoaders.length;

      if (params === 'all') {
        for (var i = 0; i < skyLoadersLen; i++) {
          state.skyLoaders[i].destroy();
        }

        state.skyLoaders.splice(0, skyLoadersLen);
      } else {
        var shuoldDelete = true;

        do {
          var index = _lodash["default"].findIndex(state.skyLoaders, function (skyLoader) {
            return skyLoader.id === params.id;
          });

          if (index < 0) {
            shuoldDelete = false;
            break;
          }

          if (state.skyLoaders[index].id !== params.id) {
            break;
          }

          shuoldDelete = false;
          var removedLoader = state.skyLoaders.splice(index, 1)[0];
          removedLoader && removedLoader.destroy && removedLoader.destroy();
        } while (shuoldDelete);
      }
    },
    UPDATE_SKY_LOADER: function UPDATE_SKY_LOADER(state, _ref7) {
      var index = _ref7.index,
          downloader = _ref7.downloader;
      state.skyLoaders.splice(index, 1, downloader);
    },
    REFRESH_VIEW: function REFRESH_VIEW(state, payload) {
      if (payload instanceof Object) {
        // 上传文件异步任务
        state.refreshView = Object.assign({}, {
          cid: state.refreshView.cid + 1
        }, payload);
      } else {
        // payload 等于Boolean, undefined
        state.refreshView = {
          cid: state.refreshView.cid + 1,
          data: null,
          taskId: null
        };
      }
    },
    SET_RELATION_SEARCH_KEYWORD: function SET_RELATION_SEARCH_KEYWORD(state, relationSearchKeyword) {
      state.relationSearchKeyword = relationSearchKeyword;
    },
    SET_VNC: function SET_VNC(state, vncOperate) {
      state.vncOperate = vncOperate;
    },
    SET_CURRENT_ACTION: function SET_CURRENT_ACTION(state, currentAction) {
      state.currentAction = currentAction;
    },
    ADD_TASK_ID: function ADD_TASK_ID(state, taskId) {
      var index = _lodash["default"].findIndex(state.taskIds, taskId);

      if (index === -1) {
        state.taskIds.push(taskId);
      }
    },
    REMOVE_TASK_ID: function REMOVE_TASK_ID(state, taskId) {
      state.taskIds.splice(_lodash["default"].findIndex(state.taskIds, taskId), 1);
    },
    ADD_ASYNCHRONOUS_TASK: function ADD_ASYNCHRONOUS_TASK(state, subscribeData) {
      var id = subscribeData.id; // 以定义id进行发布订阅，只能订阅一次

      if (id) {
        var i = _lodash["default"].findIndex(state.asynchronousTasks, function (item) {
          return item.id === id;
        });

        if (i >= 0) {
          var oldData = state.asynchronousTasks[i];
          var newData = Object.assign({}, oldData, subscribeData);
          state.asynchronousTasks.splice(i, 1, newData);
        } else {
          state.asynchronousTasks.push(subscribeData);
        }
      } else {
        state.asynchronousTasks.push(subscribeData);
      }
    },
    REMOVE_ASYNCHRONOUS_TASK_BY_TASKID: function REMOVE_ASYNCHRONOUS_TASK_BY_TASKID(state, taskId) {
      var i = _lodash["default"].findIndex(state.asynchronousTasks, function (item) {
        return item.taskId === taskId;
      });

      if (i >= 0) {
        state.asynchronousTasks.splice(i, 1);
      }
    },
    REMOVE_ASYNCHRONOUS_TASK_BY_ID: function REMOVE_ASYNCHRONOUS_TASK_BY_ID(state, taskId) {
      var i = _lodash["default"].findIndex(state.asynchronousTasks, function (item) {
        return item.taskId === taskId;
      });

      if (i >= 0) {
        state.asynchronousTasks.splice(i, 1);
      }
    }
  },
  actions: {
    HideInitLoading: function HideInitLoading(_ref8) {
      var commit = _ref8.commit;
      commit('SET_INITLOADING', false);
    },
    SetRefreshTimerId: function SetRefreshTimerId(_ref9, refreshTimerId) {
      var commit = _ref9.commit;
      commit('SET_REFRESH_TIMER_ID', refreshTimerId);
    },
    InitLoading: function InitLoading(_ref10, initLoading) {
      var commit = _ref10.commit;
      commit('SET_INITLOADING', initLoading);
    },
    SetHasFirstTimeLoggedIn: function SetHasFirstTimeLoggedIn(_ref11, hasFirstTimeLoggedIn) {
      var commit = _ref11.commit;
      commit('SET_HAS_FIRST_TIME_LOGGED_IN', hasFirstTimeLoggedIn);
    },
    SetProcessing: function SetProcessing(_ref12, processing) {
      var commit = _ref12.commit;
      commit('SET_PROCESSING', processing);
    },
    AddTaskId: function AddTaskId(_ref13, taskId) {
      var commit = _ref13.commit;
      commit('ADD_TASK_ID', taskId);
    },
    RemoveTaskId: function RemoveTaskId(_ref14, taskId) {
      var commit = _ref14.commit;
      commit('REMOVE_TASK_ID', taskId);
    },
    SetRelationSearchKeyword: function SetRelationSearchKeyword(_ref15, relationSearchKeyword) {
      var commit = _ref15.commit;
      commit('SET_RELATION_SEARCH_KEYWORD', relationSearchKeyword);
    },
    SetShowDetailPage: function SetShowDetailPage(_ref16, showDetailPage) {
      var commit = _ref16.commit;
      commit('SET_DETAIL_PAGEHIDDEN_OPERATE', showDetailPage);
    },
    setAsyncAction: function setAsyncAction(_ref17, asyncAction) {
      var commit = _ref17.commit;
      commit('SET_ASYNC_ACTION', asyncAction);
    },
    AddSkyLoader: function AddSkyLoader(_ref18, skyLoader) {
      var commit = _ref18.commit;
      commit('ADD_SKY_LOADER', skyLoader);
    },
    AddDialogMetaData: function AddDialogMetaData(_ref19, _ref20) {
      var commit = _ref19.commit;
      var metaData = _ref20.metaData,
          type = _ref20.type,
          modal = _ref20.modal;
      commit('ADD_DIALOG_META_DATA', {
        metaData: metaData,
        type: type,
        modal: modal
      });
    },
    RemoveDialogMetaData: function RemoveDialogMetaData(_ref21, metaData) {
      var commit = _ref21.commit;
      commit('REMOVE_DIALOG_META_DATA', metaData);
    },
    AddBreadcrumbMetaData: function AddBreadcrumbMetaData(_ref22, _ref23) {
      var commit = _ref22.commit;
      var metaData = _ref23.metaData;
      commit('ADD_BREADCRUMB_META_DATA', {
        metaData: metaData
      });
    },
    RemoveBreadcrumbMetaData: function RemoveBreadcrumbMetaData(_ref24, _ref25) {
      var state = _ref24.state,
          commit = _ref24.commit;
      var item = _ref25.item,
          index = _ref25.index,
          breadCrumb = _ref25.breadCrumb;

      if (state.breadcrumbMetaDatas.length <= 0) {
        return;
      }

      if (index < -1) {
        // 点击路由产生的面包屑，清空所有dialog以及面包屑
        commit('REMOVE_DIALOG_META_DATA', 'all');
      } else {
        // 点击自定义的面包屑，清空该面包屑之后的：对应dialog + 对应面包屑（不包括当前面包屑和dialog）
        var removeBreadIdx = index + 1;

        var dialogIdx = _lodash["default"].findIndex(state.dialogMetaDatas, function (dialogMetaData) {
          var _dialogMetaData$metaD, _dialogMetaData$metaD2;

          var breadcrumb = dialogMetaData === null || dialogMetaData === void 0 ? void 0 : (_dialogMetaData$metaD = dialogMetaData.metaData) === null || _dialogMetaData$metaD === void 0 ? void 0 : (_dialogMetaData$metaD2 = _dialogMetaData$metaD.view) === null || _dialogMetaData$metaD2 === void 0 ? void 0 : _dialogMetaData$metaD2.breadcrumb;

          if (_lodash["default"].isArray(breadcrumb)) {
            return _lodash["default"].findIndex(breadcrumb, function (bread) {
              return (bread === null || bread === void 0 ? void 0 : bread.id) === state.breadcrumbMetaDatas[removeBreadIdx].id;
            }) > -1;
          } else {
            return (breadcrumb === null || breadcrumb === void 0 ? void 0 : breadcrumb.id) === state.breadcrumbMetaDatas[removeBreadIdx].id;
          }
        }); // REMOVE_DIALOG_META_DATA 方法中 num 表示移除 num 之后的dialog，不包括 num


        var removeDialogIdx = dialogIdx - 1;
        commit('REMOVE_DIALOG_META_DATA', removeDialogIdx);
      }
    },
    RemoveSkyLoader: function RemoveSkyLoader(_ref26, skyLoader) {
      var commit = _ref26.commit;
      commit('REMOVE_SKY_LOADER', skyLoader);
    },
    UpdateSkyLoader: function UpdateSkyLoader(_ref27, _ref28) {
      var commit = _ref27.commit;
      var index = _ref28.index,
          downloader = _ref28.downloader;
      commit('UPDATE_SKY_LOADER', {
        index: index,
        downloader: downloader
      });
    },
    RefreshView: function RefreshView(_ref29, payload) {
      var state = _ref29.state,
          commit = _ref29.commit;
      commit('REFRESH_VIEW', payload);
    },
    OpenRelationDialog: function OpenRelationDialog(_ref30, _ref31) {
      var commit = _ref30.commit;
      var metaData = _ref31.metaData,
          props = _ref31.props,
          _ref31$clone = _ref31.clone,
          clone = _ref31$clone === void 0 ? true : _ref31$clone;
      debounceOpenRalationDialog({
        metaData: metaData,
        props: props,
        clone: clone
      });
    },
    OpenFullDialog: function OpenFullDialog(_ref32, _ref33) {
      var commit = _ref32.commit;
      var metaData = _ref33.metaData,
          props = _ref33.props,
          _ref33$clone = _ref33.clone,
          clone = _ref33$clone === void 0 ? true : _ref33$clone;
      debounceOpenFullDialog({
        metaData: metaData,
        props: props,
        clone: clone
      });
    },
    OpenDetailDialog: function OpenDetailDialog(_ref34, _ref35) {
      var commit = _ref34.commit;
      var metaData = _ref35.metaData,
          props = _ref35.props,
          _ref35$clone = _ref35.clone,
          clone = _ref35$clone === void 0 ? true : _ref35$clone;
      debounceOpenDetailDialog({
        metaData: metaData,
        props: props,
        clone: clone
      });
    },
    OpenRightDialog: function OpenRightDialog(_ref36, _ref37) {
      var commit = _ref36.commit;
      var metaData = _ref37.metaData,
          props = _ref37.props,
          _ref37$clone = _ref37.clone,
          clone = _ref37$clone === void 0 ? true : _ref37$clone;
      debounceOpenRightDialog({
        metaData: metaData,
        props: props,
        clone: clone
      });
    },
    OpenPopover: function OpenPopover(_ref38, metaData) {
      var commit = _ref38.commit;
      var viewMetaData = {
        viewMetaData: (0, _util.extend)(true, {
          isPopover: true,
          viewType: 'form',
          "class": 'sky-container--popover'
        }, metaData)
      };
      commit('SET_POPOVER_METADATA', viewMetaData);
    },
    ReturnPage: function ReturnPage() {
      this.dispatch('RemoveDialogMetaData', false);
    },
    OpenVnc: function OpenVnc(_ref39, data) {
      var commit = _ref39.commit;
      commit('SET_VNC', (data.name || data[0]) + '_' + Date.now());
    },
    OpenNotification: function OpenNotification(_ref40, _ref41) {
      var commit = _ref40.commit;
      var message = _ref41.message,
          _ref41$duration = _ref41.duration,
          duration = _ref41$duration === void 0 ? 5 * 1000 : _ref41$duration,
          _ref41$type = _ref41.type,
          type = _ref41$type === void 0 ? 'error' : _ref41$type,
          _ref41$i18n = _ref41.i18n,
          i18n = _ref41$i18n === void 0 ? true : _ref41$i18n,
          _ref41$onClose = _ref41.onClose,
          onClose = _ref41$onClose === void 0 ? noop : _ref41$onClose,
          _ref41$option = _ref41.option,
          option = _ref41$option === void 0 ? {} : _ref41$option;
      type = type.toLowerCase();
      (0, _notification2["default"])((0, _objectSpread2["default"])({
        message: i18n ? _lang["default"].t(message) : message,
        type: STATUS_MAP[type],
        duration: duration,
        alert: true,
        position: 'bottom-right',
        onClose: onClose,
        maxHeightOffset: 70
      }, Object.assign({
        restart: true
      }, option)));
    },
    OpenConfirm: function OpenConfirm(_ref42, _ref43) {
      var commit = _ref42.commit;
      var title = _ref43.title,
          message = _ref43.message,
          _ref43$i18n = _ref43.i18n,
          i18n = _ref43$i18n === void 0 ? true : _ref43$i18n,
          _ref43$placehoder = _ref43.placehoder,
          placehoder = _ref43$placehoder === void 0 ? {} : _ref43$placehoder,
          _ref43$option = _ref43.option,
          option = _ref43$option === void 0 ? {} : _ref43$option,
          _ref43$showClose = _ref43.showClose,
          showClose = _ref43$showClose === void 0 ? false : _ref43$showClose,
          confirmText = _ref43.confirmText,
          cancelText = _ref43.cancelText;
      return this._vm.$confirm(i18n ? _lang["default"].t(message, placehoder) : message, title && (i18n ? _lang["default"].t(title) : title) || _lang["default"].t('sk.tip'), (0, _objectSpread2["default"])({
        confirmButtonText: _lang["default"].t(confirmText || 'confirm'),
        cancelButtonText: _lang["default"].t(cancelText || 'cancel'),
        type: 'warning',
        showClose: showClose,
        enterKey: false
      }, option));
    },
    CloseAllNotification: function CloseAllNotification(_ref44) {
      var commit = _ref44.commit;

      _notification2["default"].closeAll();
    },
    SetCurrentAction: function SetCurrentAction(_ref45, currentAction) {
      var commit = _ref45.commit;
      commit('SET_CURRENT_ACTION', currentAction);
    },
    // 使用get请求下载,将文件下载到浏览器后，使用 window.URL.createObjectURL 创建缓存url,从浏览器的缓存中下载
    // 本方法存在一个问题: 当请求响应较久(如文件大或网络波动),前端没有任何请求，只有当整个文件下载完成后才会有提示
    DownLoadFile: function DownLoadFile(_ref46, _ref47) {
      var commit = _ref46.commit;
      var module = _ref47.module,
          _ref47$action = _ref47.action,
          action = _ref47$action === void 0 ? 'download' : _ref47$action,
          _ref47$params = _ref47.params,
          params = _ref47$params === void 0 ? {} : _ref47$params;
      debounceDownLoadFile({
        module: module,
        action: action,
        params: params
      });
    },
    ChangeLoginPasswordType: function ChangeLoginPasswordType(_ref48, params) {
      var commit = _ref48.commit;

      if (params.data.$el.type === 'input') {
        params.data.$el.type = 'password';
        params.data.$el.suffixIcon = 'sk-icon-invisible';
      } else {
        params.data.$el.type = 'input';
        params.data.$el.suffixIcon = 'sk-icon-eye';
      }
    },
    SubscribeAsynchronousTask: function SubscribeAsynchronousTask(_ref49, subscribeData) {
      var commit = _ref49.commit;

      /**
       * 订阅异步任务完成执行回调
       * 使用：
       * 页面组件在触发文件上传时调用该action添加订阅信息，{id, handle}
       * 上传组件完成上传调用upload_finish接口的回调会调用该action，保存{id, taskId}
       * 更具id合并两个对象，
       * 通过action refreshView 触发taskId相同的回调句柄
       */
      commit('ADD_ASYNCHRONOUS_TASK', subscribeData);
    },
    PublishAsynchronousTask: function PublishAsynchronousTask(_ref50, publishData) {
      var state = _ref50.state,
          commit = _ref50.commit;
      var status = publishData.status;
      var subscribeData = state.asynchronousTasks;
      var removeTaskIds = [];

      for (var index = 0; index < subscribeData.length; index++) {
        var subscribe = subscribeData[index];

        if (subscribe) {
          var success = subscribe.success,
              fail = subscribe.fail,
              partialSuccess = subscribe.partialSuccess;

          if (status === 'SUCCESS') {
            _lodash["default"].isFunction(success) && success(publishData);
          } else if (status === 'PARTIAL_SUCCESS') {
            _lodash["default"].isFunction(partialSuccess) && partialSuccess(publishData);
          } else if (typeof fail === 'function') {
            fail(publishData);
          }

          removeTaskIds.push(subscribe.taskId);
        }
      } // 移除已完成的任务订阅


      for (var _index = 0; _index < removeTaskIds.length; _index++) {
        var taskId = removeTaskIds[_index];
        commit('REMOVE_ASYNCHRONOUS_TASK_BY_ID', taskId);
      }

      removeTaskIds = null;
      /**
       * 考虑复用性，可以通过id和taskId发布
       * 现在只匹配SUCCESS状态，其他为失败
       * 页面如需区分不同的失败状态，可更具需求新增status状态
       */
      // const i = _.findIndex(state.asynchronousTasks, (item) => {
      //   return idAlias ? item.id === idAlias : item.taskId === taskId
      // })
      // if (i >= 0) {
      //   /**
      //    * 完成异步任务
      //    * 该异步任务有订阅事件，执行订阅事件
      //    */
      //   const { success, fail, id } = state.asynchronousTasks[i]
      //   const asynchronousTaskData = {
      //     id,
      //     data,
      //     status,
      //     taskId // success 有taskId，其他状态可能没有taskId
      //   }
      //   if (status === 'SUCCESS') {
      //     _.isFunction(success) && success(asynchronousTaskData)
      //   } else if (typeof fail === 'function') {
      //     fail(asynchronousTaskData)
      //   }
      //   commit('REMOVE_ASYNCHRONOUS_TASK_BY_ID', taskId)
      // }
    },
    OpenDetailByRouter: function OpenDetailByRouter(_ref51, _ref52) {
      var commit = _ref51.commit;
      var props = _ref52.props,
          routeName = _ref52.routeName,
          metaData = _ref52.metaData,
          clone = _ref52.clone,
          detailPageTitle = _ref52.detailPageTitle;
      clone && (metaData = (0, _util.extend)(true, {}, metaData));
      (0, _utils.backfill)(metaData, (0, _objectSpread2["default"])({}, props));

      var curRoute = _router["default"].matcher.getRouteByName(routeName);

      if (curRoute) {
        curRoute.meta.hiddenAll = true;
        var currentRouteName = routeName + '-detail';
        var detailPageRoute = {
          path: currentRouteName,
          name: currentRouteName,
          parentName: routeName,
          meta: {
            detailPageTitle: detailPageTitle,
            viewMetaData: metaData
          }
        };

        _router["default"].matcher.addRoutes([detailPageRoute]);

        _router["default"].push({
          name: currentRouteName
        });

        _router["default"].matcher.deleteRouteByName(currentRouteName);
      } else {
        throw new Error(' current route ' + routeName + ' is not find');
      }
    },
    GetPersistenceColumn: function GetPersistenceColumn(_ref53, _ref54) {
      var commit = _ref53.commit;
      var functionType = _ref54.functionType;
      return (0, _index2.fetch)(_index2.PERSISTENCE_COLUMN_URL, {
        functionType: functionType
      }).then(function (response) {
        var data = response.data.content || {};
        return data.columnTextArr || [];
      })["catch"](function (e) {
        throw e;
      });
    },
    PersistenceColumn: function PersistenceColumn(_ref55, _ref56) {
      var commit = _ref55.commit;
      var functionType = _ref56.functionType,
          columnTextArr = _ref56.columnTextArr;
      return (0, _skAxios.post)(_index2.SAVE_PERSISTENCE_COLUMN_URL, {
        functionType: functionType,
        columnTextArr: columnTextArr
      }).then(function (response) {
        return response;
      })["catch"](function (e) {
        throw e;
      });
    }
  }
};
var _default = app;
exports["default"] = _default;